import { throttle, find } from "lodash-es"
import { Collapse} from "bootstrap"

// Code copied directly from old application.

// Esta implementación expone init/destroy para soportar Turbo (montar/desmontar)
let navbarInstance = null

function initNavbar() {
  if (navbarInstance) return

  const navbar = document.querySelector('nav.navbar')
  if (!navbar) return

  const defaultNavbarHeight = 75 // Navbar height when shrink (used in scrollTo)
  const navbarCollapse = navbar.querySelector('#navbar-collapse')
  const navLinks = Array.from(navbar.querySelectorAll('.nav-link.page-scroll'))
  const scrollLinks = Array.from(document.querySelectorAll('a.page-scroll:not(.nav-link)'))
  const sections = Array.from(document.querySelectorAll('header[id], section[id]')).reverse()

  function resetNavLinks() {
    navLinks.forEach(l => {
      l.parentElement.classList.remove('active')
      l.classList.remove('active')
    })
  }

  function shrinkNavbar() {
    if (window.pageYOffset >= 50) {
      navbar.classList.add('navbar-shrink')
    } else {
      navbar.classList.remove('navbar-shrink')
    }
  }

  function highlightMenuEntry() {
    sections.forEach(s => {
      const navbarHeight = document.querySelector('.navbar')?.clientHeight || 0
      const rect = s.getBoundingClientRect()
      const isVisible = rect.top < window.innerHeight && rect.bottom - navbarHeight >= 0
      if (isVisible) {
        resetNavLinks()
        const link = find(navLinks, l => l.hash === `#${s.id}`)
        link.parentElement.classList.add('active')
        link.classList.add('active')
      }
    })
  }

  const onScroll = throttle(() => {
    shrinkNavbar()
    highlightMenuEntry()
  }, 300, { leading: true, trailing: true, maxWait: 300 })

  function scrollToHandler(e, element) {
    if (element.href.indexOf(window.location.pathname) !== -1) {
      e.preventDefault()
      const section = document.getElementById(element.href.split('#')[1])
      const bodyRect = document.body.getBoundingClientRect().top
      const position = section.getBoundingClientRect().top
      // Collapse must be initialized before calling hide
      window.scrollTo({ top: position - bodyRect - defaultNavbarHeight + 1, behavior: 'smooth' })
      Collapse.getInstance(navbarCollapse).hide()
    }
    return null
  }

  function navLinkOnClick(e) {
    e.preventDefault()
    resetNavLinks()
    e.target.parentElement.classList.add('active')
    e.target.classList.add('active')
    scrollToHandler(e, e.target)
  }

  function scrollLinkOnClick(e) {
    const target = e.currentTarget
    scrollToHandler(e, target).then(() => resetNavLinks())
  }

  // Añadir listeners
  navLinks.forEach(l => l.addEventListener('click', navLinkOnClick))
  scrollLinks.forEach(l => l.addEventListener('click', scrollLinkOnClick))
  window.addEventListener('scroll', onScroll)

  // Estado inicial
  shrinkNavbar()
  highlightMenuEntry()

  // Guardar referencias para desmontar
  navbarInstance = {
    navbar,
    navLinks,
    scrollLinks,
    handlers: {
      onScroll,
      navLinkOnClick,
      scrollLinkOnClick,
      resetNavLinks
    }
  }
}

function destroyNavbar() {
  if (!navbarInstance) return

  const { navLinks, scrollLinks, handlers, navbar } = navbarInstance
  window.removeEventListener('scroll', handlers.onScroll)
  navLinks.forEach(l => l.removeEventListener('click', handlers.navLinkOnClick))
  scrollLinks.forEach(l => l.removeEventListener('click', handlers.scrollLinkOnClick))

  handlers.resetNavLinks()
  navbar.classList.remove('navbar-shrink')

  navbarInstance = null
}

// Enganchar a eventos de Turbo y fallback a DOMContentLoaded
if (typeof document !== 'undefined') {
  document.addEventListener('turbo:load', initNavbar)
  document.addEventListener('turbo:before-cache', destroyNavbar)
  // Fallback por si no se usa Turbo o para la primera carga en navegadores/entornos sin Turbo
  document.addEventListener('DOMContentLoaded', initNavbar)
}
